import { render, staticRenderFns } from "./scalapay-widget.vue?vue&type=template&id=5e654f5f&"
import script from "./scalapay-widget.vue?vue&type=script&lang=js&"
export * from "./scalapay-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports